export default "__VITE_ASSET__gkddiefZ__"